import { Outlet, useNavigate } from 'react-router';
import { useEffect } from 'react';
import { useAuth } from '@/contexts/auth-context';

export function SettingsLayout() {
  const navigate = useNavigate();
  const { userMode, isReady } = useAuth();

  useEffect(() => {
    if (isReady && userMode === 'enduser') {
      navigate('/dashboard', { replace: true });
    }
  }, [isReady, userMode, navigate]);

  if (!isReady || userMode === 'enduser') return null;

  return (
    <div className="w-full">
      <Outlet />
    </div>
  );
}
